// extracted by mini-css-extract-plugin
export default {"date":"DateCell_date__f3OJb","holiday":"DateCell_holiday__O8POU"};